<template>
  <div class="pa-16 d-flex flex-column align-center justify-center">
    <ErrorSVG />
    <div class="d-flex flex-column align-center justify-center my-6 ga-4 text-container">
      <h1 class="text-body-1 font-weight-semibold">
        {{ title ?? t('error.somethingWentWrong') }}
      </h1>
      <p class="text-body-2 font-weight-semibold text-center">
        {{ errorMessage }}
      </p>
      <p class="text-body-2 text-medium-emphasis text-center">
        {{ description ?? t('error.description') }}
      </p>
      <div class="mt-6 d-flex grow justify-center ga-3">
        <template
          v-for="action in actions"
          :key="action.label"
        >
          <VBtnSecondary
            v-if="action.options?.type === 'secondary'"
            :append-icon="action.options?.icon"
            @click="action.onClick"
          >
            {{ action.label }}
          </VBtnSecondary>
          <VBtnPrimary
            v-else
            :append-icon="action.options?.icon"
            @click="action.onClick"
          >
            {{ action.label }}
          </VBtnPrimary>
        </template>
      </div>
    </div>
    <div class="text-body-2 text-medium-emphasis position-absolute">
      <i18n-t
        keypath="error.contactSupport"
        tag="span"
      >
        <a
          class="text-body-2 font-weight-semibold button-link"
          href="mailto:support@teamworks.com"
        >
          {{ t('error.teamworksSupport') }}
        </a>
      </i18n-t>
    </div>
  </div>
</template>

<script setup lang="ts">
import ErrorSVG from '@/components/common/ErrorSVG.vue';
import { useI18n } from 'vue-i18n';


const { t } = useI18n();

export type ErrorStateAction = {
  label: string;
  onClick?: () => void;
  options?: {
    type?: 'primary' | 'secondary';
    icon?: string;
  };
};

const {
  title,
  description,
  errorMessage,
  actions = [],
} = defineProps<{
  title?: string;
  description?: string;
  errorMessage?: string;
  actions: ErrorStateAction[];
}>();

</script>

<style scoped lang="scss">
.position-absolute {
  position: absolute;
  bottom: 40px;
}
.button-link {
  color: rgb(var(--v-theme-info));
  cursor: pointer;
}
.text-container {
  max-width: 360px;
}
</style>
